 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		62: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"9eb48661daf350bbc0973d2b2cee0cc621caea2d","1":"a12e199a26be23319f936d3abb302f05c989e4f7","2":"325cf59fe1c456cc7727d775dcde522810e9cdb9","3":"component---src-pages-about-us-components-our-company-tsx","4":"component---src-pages-services-business-operations-components-services-tsx","5":"component---src-pages-services-business-strategy-components-enterprise-function-consulting-tsx","6":"component---src-pages-services-business-strategy-components-services-tsx","7":"component---src-pages-services-cloud-cloud-application-management-components-let-us-manage-you-app-tsx","8":"component---src-pages-services-cloud-components-stats-tsx","9":"component---src-pages-services-technology-support-components-support-via-innovation-tsx","10":"fb59c800e5bc77d1a87b75443cc4fa96d3771640","12":"component---src-pages-404-tsx","13":"component---src-pages-about-us-components-digital-at-scale-tsx","14":"component---src-pages-about-us-components-intro-tsx","15":"component---src-pages-about-us-index-tsx","16":"component---src-pages-about-us-innovation-components-intro-tsx","17":"component---src-pages-about-us-innovation-index-tsx","18":"component---src-pages-all-files-tsx","19":"component---src-pages-all-markdown-tsx","20":"component---src-pages-contact-us-components-options-tsx","21":"component---src-pages-contact-us-index-tsx","22":"component---src-pages-index-tsx","23":"component---src-pages-industries-components-intro-tsx","24":"component---src-pages-industries-index-tsx","25":"component---src-pages-services-business-operations-components-business-operations-outcome-tsx","26":"component---src-pages-services-business-operations-components-intro-tsx","27":"component---src-pages-services-business-operations-index-tsx","28":"component---src-pages-services-business-operations-outsourcing-components-capabilities-tsx","29":"component---src-pages-services-business-operations-outsourcing-index-tsx","30":"component---src-pages-services-business-strategy-components-are-you-prepared-tsx","31":"component---src-pages-services-business-strategy-components-capabilites-tsx","32":"component---src-pages-services-business-strategy-components-intro-tsx","33":"component---src-pages-services-business-strategy-images-business-intelligence-and-analytics-consulting-image-tsx","34":"component---src-pages-services-business-strategy-images-cloud-strategy-and-adoption-image-tsx","35":"component---src-pages-services-business-strategy-index-tsx","36":"component---src-pages-services-cloud-cloud-application-development-components-capabilities-tsx","37":"component---src-pages-services-cloud-cloud-application-development-components-helpful-cloud-native-tsx","38":"component---src-pages-services-cloud-cloud-application-development-index-tsx","39":"component---src-pages-services-cloud-cloud-application-management-components-capabilities-tsx","40":"component---src-pages-services-cloud-cloud-application-management-index-tsx","41":"component---src-pages-services-cloud-cloud-native-index-tsx","42":"component---src-pages-services-cloud-components-are-you-prepared-tsx","43":"component---src-pages-services-cloud-components-capabilites-tsx","44":"component---src-pages-services-cloud-components-intro-tsx","45":"component---src-pages-services-cloud-components-terms-tsx","46":"component---src-pages-services-cloud-enterprise-cloud-strategy-components-capabilities-tsx","47":"component---src-pages-services-cloud-enterprise-cloud-strategy-components-deffine-your-strategy-tsx","48":"component---src-pages-services-cloud-enterprise-cloud-strategy-index-tsx","49":"component---src-pages-services-cloud-index-tsx","50":"component---src-pages-services-cloud-modernization-components-getting-started-tsx","51":"component---src-pages-services-cloud-modernization-components-maximise-application-migration-tsx","52":"component---src-pages-services-cloud-modernization-index-tsx","53":"component---src-pages-services-components-intro-tsx","54":"component---src-pages-services-index-tsx","55":"component---src-pages-services-technology-support-components-capabilities-tsx","56":"component---src-pages-services-technology-support-components-intro-tsx","57":"component---src-pages-services-technology-support-components-long-term-benefits-tsx","58":"component---src-pages-services-technology-support-index-tsx","59":"component---src-templates-blog-post-tsx"}[chunkId]||chunkId) + "-" + {"0":"e1c5035e74f98a3740be","1":"47d33587b7cbb54a7248","2":"1e25c26e69e697174653","3":"cff75db304ed90bcc011","4":"7e0c96f32ed50ec610f0","5":"7d8c64f395aba42b84bf","6":"b20cd7843c5bccf7e5ec","7":"71236689b25945c81a69","8":"1938bba359f4a01e3f74","9":"12cca3b72b8d99c62d16","10":"bca973e5910c93a18577","12":"5ece5e667d3d232c6095","13":"a072b3754878559911b8","14":"105507ff2eb3823791c8","15":"ee4cdaa8cc8e59987e5c","16":"bf26fbe9d61440998b81","17":"c6b9a3cf90dce3a78b1b","18":"fd6a6d99a98dbec34fe0","19":"d9ce62c448c615b8438c","20":"fbd07822387a6309fbf4","21":"6725f14ac6691e9a7d03","22":"d092693bf11881853fbf","23":"f2047c9ed48933624673","24":"f4c6981b98acd3941813","25":"d6b75d8e2d994bc0a84b","26":"c4bb2c4e2e857ffe6777","27":"6cba1929ecd32f660b37","28":"32daa8e9db2caa84e0e0","29":"bf8d932737b2394ca58c","30":"6aa4b18bf19c23a5c933","31":"c1ff58beffaba0dded3f","32":"8b47015a6f22b46a8ff5","33":"f39f51d282a506d6cbfc","34":"a5e6615add6ecd4df0e1","35":"8d3a13f60675b44e85a7","36":"72b36fe43a83ea4644fc","37":"0325b00c965220e3b0b8","38":"891bc278f8af2bbaf878","39":"638af5700513a5e71722","40":"b4f886b0a363beab8398","41":"135017228bc105e50454","42":"a8c5ec81bf0f0f5d80c4","43":"32465878888f081a3c79","44":"ee07437fcfa73ef54e62","45":"7b3a62159b6d6be656aa","46":"00660537489cd9ae962e","47":"a0e05778e3fba176d137","48":"65dfa5e86cb1e8275f2f","49":"6c3a87c9b0a0418df2ba","50":"c313c57bcdf80e15087b","51":"938de3a042d0ec94ae2d","52":"d6c41256d02d02402f2b","53":"2dc42da6512708edbe91","54":"841adb0e3586c7e0741a","55":"f1b9e2d9bec84cdf3cf3","56":"2ceb82c41ed7c388fa4c","57":"a448f8e68cb6b5a8f53a","58":"61d3cd450e8571cf6fc2","59":"e6b4c3733b9ec37de051"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
